<!-- CTA Section start-->
<section class="cta-section" id="enquiry">
    <div class="container cta-content">
        <div class="row align-items-center g-5">

            <!-- Left Side Content -->
            <div class="col-lg-5">
                <div class="pe-lg-4">
                    <span class="badge bg-white text-dark px-4 py-3 mb-4 fs-6">
                        <i class="bi bi-droplet-fill me-2"></i> INSTANT CONSULTATION
                    </span>

                    <h2 class="cta-heading text-white">Ready to Feel Rejuvenated?</h2>
                    <p class="lead opacity-90 mb-3">
                        Book your personalized IV therapy session with our expert team.
                        Experience science-backed wellness like never before.
                    </p>

                    <!-- Contact Information -->
                    <div class="cta-contact-info">
                        <!-- Phone -->
                        <a href="tel:+916262662662" class="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                                fill="white">
                                <path
                                    d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.07 21 3 13.93 3 5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.24.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z">
                                </path>
                            </svg>
                            <div>
                                Call us now<br>
                                <strong>+916262662662</strong>
                            </div>
                        </a>

                        <!-- WhatsApp -->
                        <a href="https://api.whatsapp.com/send?phone=916262662662&text=I%20am%20interested%20!%20Please%20share%20me%20more%20details%20about%20Red%20Monk%20Welness%20!"
                            target="_blank" class="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
                                fill="white">

                                <path
                                    d="M16.04 3C8.84 3 3 8.74 3 15.82c0 2.5.74 4.93 2.13 7L3 29l6.37-2.05a13.2 13.2 0 0 0 6.67 1.82h.01C23.2 28.77 29 23.03 29 15.95 29 8.87 23.2 3 16.04 3zm0 23.6c-2.06 0-4.08-.55-5.85-1.6l-.42-.25-3.78 1.22 1.23-3.68-.28-.44a10.5 10.5 0 0 1-1.64-5.63c0-5.87 4.82-10.65 10.75-10.65 5.92 0 10.74 4.78 10.74 10.65 0 5.88-4.82 10.67-10.75 10.67zm5.89-8.03c-.32-.16-1.9-.93-2.2-1.03-.3-.1-.52-.16-.74.16-.22.31-.85 1.03-1.05 1.24-.19.21-.39.24-.71.08-.32-.16-1.35-.49-2.57-1.56-.95-.83-1.59-1.85-1.78-2.16-.19-.31-.02-.48.14-.64.14-.14.32-.37.48-.55.16-.18.21-.31.32-.52.1-.21.05-.39-.03-.55-.08-.16-.74-1.77-1.01-2.43-.27-.64-.54-.55-.74-.56h-.63c-.21 0-.55.08-.84.39-.29.31-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.22 3.37 5.38 4.73.75.32 1.34.51 1.8.65.76.24 1.45.21 2 .13.61-.09 1.9-.78 2.17-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z">
                                </path>
                            </svg>
                            <div>
                                Chat on WhatsApp<br>
                                <strong>+91 6262662662</strong>
                            </div>
                        </a>

                        <!-- Email -->
                        <a href="mailto:info@redmonkwellness.com">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                                fill="white">
                                <path
                                    d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 3.2-8 5.3-8-5.3V6l8 5.3L20 6v1.2z">
                                </path>
                            </svg>
                            <div>
                                Send us an email<br>
                                <strong>info@redmonkwellness.com</strong>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Right Side Form -->
            <div class="col-lg-7">
                <div class="form-card">
                    <h3 class="mb-3 pb-3 border-bottom">
                        Enquire for More Details
                    </h3>

                    <div id="formErrors" class="text-danger mb-2" style="display:none;"></div>
                    <div id="msgSubmit" class="text-success hidden mb-2"></div>

                    <form id="enquiry-form" action="#" method="post">
                        <div class="row">
                            <div class="col-md-6">
                                <!-- <input type="text" class="form-control" placeholder="Your name here*" required> -->
                                <input class="form-control" id="name" [(ngModel)]="enquiryForm.Name" type="text"
                                    name="name" placeholder="Your name here*" />
                                <span id="error-fname" class="error-message"></span>
                            </div>
                            <div class="col-md-6">
                                <!-- <input type="email" class="form-control" placeholder="Your email here*" required> -->
                                <input class="form-control" id="email" [(ngModel)]="enquiryForm.Email" type="text"
                                    name="email" placeholder="Your email here*" />
                                <span id="error-email" class="error-message"></span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <input class="form-control" id="phone" [(ngModel)]="enquiryForm.Phone" type="text"
                                    name="phone" placeholder="Your phone here*" />
                                <span id="error-phone" class="error-message"></span>
                            </div>
                            <!-- <div class="col-md-6">
                                <input class="form-control" id="subject" [(ngModel)]="enquiryForm.Location" type="text"
                                    name="subject" placeholder="Your location here*" />
                                <span id="error-location" class="error-message"></span>
                            </div> -->
                             <div class="col-md-6">
                                <select class="form-control" id="city" [(ngModel)]="enquiryForm.CityID" name="city">
                                    <option [ngValue]="null" disabled>Select City*</option>
                                    <option *ngFor="let city of cities" [ngValue]="city.CityID">{{ city.CityName }}</option>
                                </select>
                                <span id="error-location" class="error-message"></span>
                            </div>
                        </div>

                        <p class="mt-1 mb-3 fw-bold text-dark">Interested in*</p>
                        <div class="row">
                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="IV Therapy" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">IV Therapy</span>
                                </label>

                            </div>
                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="Treatments" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">Treatments</span>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="Both(IV & Treatments)" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">Both(IV & Treatments)</span>
                                </label>
                            </div>

                            <div class="col-3">
                                <label class="custom-radio">
                                    <input type="radio" [(ngModel)]="enquiryForm.Interest" name="brand"
                                        value="Not Sure" />
                                    <span class="radio-circle"></span>
                                    <span class="radio-text">Not Sure</span>
                                </label>
                            </div>
                            <span id="error-brand" class="error-message"></span>
                        </div>

                        <textarea class="form-control" [(ngModel)]="enquiryForm.Message" id="message" name="message"
                            rows="" placeholder="Your message here*"></textarea>
                        <span id="error-message" class="error-message"></span>

                        <div class="form-check mt-2 mb-2">
                            <label class="consent-label">
                                <input type="checkbox" class="consent-checkbox" [(ngModel)]="enquiryForm.consent"
                                    id="consent" name="consent" required>
                                <span class="consent-text">
                                    By submitting this form, you hereby grant us permission
                                    to contact you via
                                    <span>SMS, WhatsApp, RCS, Email</span>, and any other
                                    communication channel.
                                </span>
                            </label>

                            <span id="error-message" class="error-message"></span>

                        </div>

                        <div class="text-start">
                            <!-- <button type="submit" class="submit-btn w-100">
                                SUBMIT ENQUIRY
                            </button> -->
                            <button class="submit-btn" type="button" (click)="submitEnquiryForm()" id="submitBtn">
                                <span id="submitText">Submit</span>
                                <span id="submitLoader" style="display:none;">⏳</span>
                            </button>
                        </div>
                        <div class="quform-loading-wrap text-start">
                            <span class="quform-loading"></span>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section end-->